// Dependencies imports
import React, { useState } from 'react';
import swal from 'sweetalert';
import { makeStyles } from '@material-ui/core/styles';
import { Constants } from "../../config/constants";
import config from "../../config/aws-exports";
import { API } from "aws-amplify";
import { useSelector } from "react-redux";
import { authData } from "../../redux/auth/authSlice";
import CircularProgress from '@material-ui/core/CircularProgress';

// Local imports

// Styles imports
import Add from './AddEvent.module.scss';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    heigth: "100%",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent"
  },
}));

const DisbleUser = (props) => {
    let { handleClose ,editUserData,getUsersDetails} = props;
    const [spin , setSpin] = useState(false);
    const classes = useStyles();
    // alert("1"+JSON.stringify(editEventData))

    let userDetails = useSelector(authData);

    const onsubmit = () => {
        updateuser();    
    };

    async function updateuser(){
      setSpin(true);
      console.log(editUserData);
       
        const bodyParam = {
            body: {
                oid: config.aws_org_id,
                eid:editUserData.col9,
                action: editUserData.col5 === "Active" ? 1 : 0,
                urole: editUserData.col3,
            },
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
          };
          console.log("bd" + JSON.stringify(bodyParam.body));
          try {
            const response = await API.post(
              config.aws_cloud_logic_custom_name,
              Constants.GET_UPDATEUSERSATUS,
              bodyParam
              //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
            );
            console.log(response);
            // const users = response;
            if (response === "User Enabled") {
              swal({
                title: "Success",
                text: "User Enabled Successfully",
                icon: "success",
                dangerMode: false,
                closeOnClickOutside: false,
              }).then((willDelete) => {
                if (willDelete) {
                  window.location.reload();
                  setSpin(false);
                }
              });
              setSpin(false);
              handleClose();
              getUsersDetails();
            }  else {
              swal({
                title: "Sucess",
                text: "User Disabled Successfully!",
                icon: "success",
                dangerMode: false,
                closeOnClickOutside: false,
              }).then((willDelete) => {
                
                if (willDelete) {
                  window.location.reload();
                  setSpin(false);
                }
              });
              setSpin(false);
              handleClose();
              getUsersDetails();
            };
          } catch (error) {
            swal({
                title:  "Oooops!",
                text:  "Soomthing wrong!",
                icon: "warning",
                dangerMode: true,
                closeOnClickOutside: false,
              })
              .then(willDelete => {
                if (willDelete) {
                  window.location.reload();
                  setSpin(false);
                }
              });
              setSpin(false);
            console.log("getUserError", error);
          }
          console.log("Mount");
    }
    return (
      <div>
      {spin === false ?
        <div className={Add.mainpopup}>
            {/* <h3 className={Add.header}>Delete Event</h3> */}
            <div className={Add.form}>
                <form>
                    {editUserData.col5 === "Active" ? <div className={Add.header}>You want to disable the user ?</div> : <div className={Add.header}>You want to Enable the user ?</div>}
                    <div className={Add.buttonholder}>
                        <button className={Add.submit} onClick={onsubmit} >Yes</button>
                        <button className={Add.cancel}  onClick={handleClose}>NO</button>
                    </div>
                </form>
            </div>
        </div> : <div className={classes.root}>
          <CircularProgress style={{ color: Constants.main_color_1 }} /></div>}
        </div>
    );
};

export default DisbleUser;